
/******/ (() => { // webpackBootstrap
    var __webpack_exports__ = {};
    Shopify.theme.jsFeaturedCollections = {
      init: function ($section) {
  
        // Add settings from schema to current object
        Shopify.theme.jsFeaturedCollections = $.extend(this, Shopify.theme.getSectionData($section));
  
        let $sliderEl = $section.find('[data-slider].is-slider-first');
  
        if (this.collection_style == 'slider') {
          this.createSlider($sliderEl,$section);
        }
        $(document).on("click",".collection-handle-btn",function(){
          var tag = $(this).attr("data-handle");
          $sliderEl.flickity('destroy');
          $sliderEl = $section.find('[data-slider].'+tag+'_slider');

          $section.find(".collection-handle-btn").removeClass("is-active");
          $(this).addClass("is-active");
          
          $section.find("[data-slider]").addClass("is-hidden");
          $sliderEl.removeClass("is-hidden");
          Shopify.theme.jsFeaturedCollections.createSlider($sliderEl,$section);
        });
      },
      createSlider: function ($sliderEl,$section) {
  
        const slideData = {
          products_per_slide: this.products_per,
          products_available: this.products_available,
          products_limit: this.products_limit,
        }
  
        const slider = $sliderEl.flickity({
          lazyLoad: 2,
          freeScroll: true,
          imagesLoaded: true,
          draggable: true,
          cellAlign: 'center',
          wrapAround: false,
          pageDots: false,
          contain: true,
          prevNextButtons: slideData.products_limit > slideData.products_per_slide ? true : false,
          initialIndex: 0,
          arrowShape: arrowShape,
          groupCells: true

        });
        slider.on('settle.flickity', function () {
          slider.flickity('resize');
        });
        
        slider.on( 'scroll.flickity', function( event, progress ) {
          $progressBar = $section.find(".slider_progrssbar");
          progress = Math.max( 0, Math.min( 1, progress ) );
          $progressBar.width( progress * 100 + '%' );
        });
  
      },
      unload: function ($section) {
        let $slider = $section.find('.flickity-enabled');
        $slider.flickity('destroy');
      }
    }
  
    /******/
  })()
    ;